import { twMerge } from 'tailwind-merge';

import { walletAddressEllipsis } from 'utils/ellipsis.utils';

import { AnalyticsTableRow } from './AnalyticsTableRow';

type AnalyticsTableItemProps = {
  rank: string;
  walletAddress: string;
  wnftPurchased: string;
  prize: string;
  isActive?: boolean;
};

export const AnalyticsTableItem = ({
  rank,
  walletAddress,
  wnftPurchased,
  prize,
  isActive = false,
}: AnalyticsTableItemProps) => {
  const variantStyles = {
    active: 'tw-bg-referralAnalyticsActiveRowGradient',
    inactive: 'tw-bg-referralAnalyticsRowGradient',
  } as const;

  const priceText = prize || '-';

  return (
    <div
      className={twMerge(
        'tw-flex tw-min-h-[26px] tw-flex-row tw-items-center tw-gap-[16px] tw-py-[4px]',
        isActive ? variantStyles.active : variantStyles.inactive
      )}
    >
      <AnalyticsTableRow text={rank} width="tw-flex-[0.3]" />
      <AnalyticsTableRow text={walletAddressEllipsis(walletAddress)} />
      <AnalyticsTableRow text={wnftPurchased} />
      <AnalyticsTableRow text={priceText} />
    </div>
  );
};
